const readStoredPositiveId = (key) => {
  try {
    const rawValue = localStorage.getItem(key);
    if (!rawValue || rawValue === "null" || rawValue === "undefined") {
      return null;
    }

    const parsed = Number(JSON.parse(rawValue));
    return Number.isInteger(parsed) && parsed > 0 ? parsed : null;
  } catch {
    return null;
  }
};

export const getAuthorizedCompanyContext = () => {
  const selectedCompanyId = readStoredPositiveId("selectedCompany");
  if (!selectedCompanyId) return null;

  try {
    const userData = JSON.parse(localStorage.getItem("userData") || "null");
    if (!userData) return null;
    const isSuperAdmin =
      userData.is_superadmin === true || Number(userData.is_superadmin) === 1;
    if (isSuperAdmin) {
      return selectedCompanyId;
    }

    const warehouses = Array.isArray(userData.assigned_warehouses)
      ? userData.assigned_warehouses
      : [];
    return warehouses.some(
      (warehouse) => Number(warehouse?.company_id) === selectedCompanyId,
    )
      ? selectedCompanyId
      : null;
  } catch {
    return null;
  }
};
